import Select from "react-select";

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    border: "none",
    color: "white",
    display: "flex",
    alignItems: "center",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "black",
    color: "white",
    display: "flex",
    alignItems: "center",
  }),
  singleValue: (provided, { data }) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    color: "white",
  }),
};

const CurrencyInputWithFlag = ({
  selectedCurrency,
  handleCurrencyChange,
  textblack = false,
  readOnly = false,
  amount,
  handleAmount,
  countryData,
}) => {
  return (
    <div
      className={`p-4  text-white ${
        textblack && "!text-black"
      } rounded-xl shadow-lg border border-gray-700 flex items-center justify-between`}
    >
      <input
        className="bg-transparent text-2xl outline-none px-4 w-8/12 font-semibold [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        decimalsLimit={2}
        type="number"
        readOnly={readOnly}
        defaultValue={amount}
        onChange={(e) => handleAmount(e?.target.value)}
        placeholder="0.00"
      />

      <Select
        options={countryData}
        getOptionValue={(e) => e?.currencyCode}
        value={selectedCurrency}
        onChange={(e) => handleCurrencyChange(e)}
        styles={customStyles}
        className={`cursor-pointer w-4/12  ${textblack && "!text-black"}`}
        formatOptionLabel={(e) => (
          <div className={`flex items-center ${textblack && "!text-black"}`}>
            {e?.currencyCode}
          </div>
        )}
      />
    </div>
  );
};

export default CurrencyInputWithFlag;
